import { Component, OnInit } from '@angular/core';
import { ClienteService } from '../../services/cliente.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

import swal from 'sweetalert2';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'app-gestiones-sidebar-menu',
  templateUrl: './gestiones-sidebar-menu.component.html',
  styleUrls: ['./gestiones-sidebar-menu.component.scss']
})
export class GestionesSidebarMenuComponent implements OnInit {
  abflag=false
  constructor(
    private clienteService: ClienteService,
    private router: Router,
    private ngxPermissionService: NgxPermissionsService,
    private authService: AuthService,
  ) {
    setTimeout(() => {
      this.abflag=this.ngxPermissionService.getPermission('evaluacionTipoAgenteBancario')!=null?true:false
    }, 4000);
  }

  ngOnInit(): void {
  }

  get canLogout(): boolean {
    return this.authService.canLogout();
  }
  logOut() {
    this.clienteService.logOut();
  }
  showPregunta() {

    if (!this.canLogout) {
      return;
    }
    swal.fire({
      title: 'Alerta',
      text: '¿Desea cerrar sesión?',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        denyButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      showDenyButton: true,
      confirmButtonText: 'Si',
      denyButtonText: 'No',
    }).then(result => {
      if (result.isConfirmed) {
        this.logOut();
        this.router.navigate(['/login']);
      } else if (result.isDenied) {
      }
    });
  }
}
